import { create } from 'zustand';
import { api } from '../lib/api';

export interface UserProfile {
  cognitoId: string;
  displayName: string;
  fullName: string;
  isOwner: boolean;
  isAdmin: boolean;
  isDisabled: boolean;
  stripeConnectAccountId?: string;
}

interface AuthState {
  user: UserProfile | null;
  checkAuth: () => Promise<void>;
  setUser: (_user: UserProfile | null) => void;
  refreshProfile: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,

  checkAuth: async () => {
    try {
      // Get the access token from localStorage (set by react-oidc-context)
      const token = localStorage.getItem('accessToken');
      
      if (!token) {
        set({ user: null });
        return;
      }

      // Fetch user profile from backend
      try {
        const { profile } = await api.get<{ profile: UserProfile }>('/users/profile');
        set({ user: profile });
      } catch {
        // Profile doesn't exist yet - user needs to complete signup
        set({ user: null });
      }
    } catch {
      set({ user: null });
    }
  },

  setUser: (user) => {
    set({ user });
  },

  refreshProfile: async () => {
    try {
      const { profile } = await api.get<{ profile: UserProfile }>('/users/profile');
      set({ user: profile });
    } catch (error) {
      console.error('Failed to refresh profile:', error);
    }
  },
}));

